import { render, staticRenderFns } from "./addspecial.vue?vue&type=template&id=53adbd76&scoped=true"
import script from "./addspecial.vue?vue&type=script&lang=js"
export * from "./addspecial.vue?vue&type=script&lang=js"
import style0 from "./addspecial.vue?vue&type=style&index=0&id=53adbd76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53adbd76",
  null
  
)

export default component.exports